// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaSearch, FaEdit,FaTrash, FaSignOutAlt, FaArrowLeft, FaCalendarAlt, FaTimes } from "react-icons/fa";
// import "./IncomeReport.css"; 
// import topLogo from "./logo-placeholder.png"; 

// const DeleteEntry = () => {
//   const navigate = useNavigate();
//   const [searchDate, setSearchDate] = useState("");
//   const [entries, setEntries] = useState([]);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [hasSearched, setHasSearched] = useState(false);
//   const [popupMessage, setPopupMessage] = useState(null);
  
//   // NEW STATE: Holds the specific entry the user wants to delete
//   const [entryToVerify, setEntryToVerify] = useState(null);

//   // --- SEARCH BY DATE ---
//  // --- SEARCH BY DATE ---
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchDate) return;

//     setIsLoading(true);
//     setHasSearched(true);
//     setEntries([]); 
//     setEntryToVerify(null); 

//     try {
//       const response = await fetch("/api/dashboard/search-entries-by-date", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ searchDate }),
//       });
//       const result = await response.json();

//       if (result.success) {
//         setEntries(result.data);
//       } else {
//         // REPLACE ALERT WITH POPUP
//         setPopupMessage(result.message || "इस दिनांक का कोई रिकॉर्ड नहीं मिला।");
//       }
//     } catch (error) {
//       // REPLACE ALERT WITH POPUP
//       setPopupMessage("सर्वर कनेक्शन त्रुटि (Server Connection Error).");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // --- ACTUAL DELETE FUNCTION ---
//   // This only runs AFTER the user verifies the details in the popup
// // --- ACTUAL DELETE FUNCTION ---
//   const confirmDeletion = async () => {
//     if (!entryToVerify) return;

//     const entryId = entryToVerify.id || entryToVerify.ID || entryToVerify.Id;

//     if (!entryId) {
//         alert("त्रुटि (Error): इस रिकॉर्ड में ID मौजूद नहीं है। (ID is missing)");
//         return;
//     }

//     setIsDeleting(true); // <-- TURN ON PROGRESS BAR

//     try {
//       const response = await fetch(`/api/dashboard/delete-entry/${entryId}`, {
//         method: "DELETE",
//       });
//       const result = await response.json();

//       if (result.success) {
//         alert("सफलता! " + result.message);
//         setEntries(entries.filter((entry) => (entry.id || entry.ID) !== entryId)); 
//         setEntryToVerify(null); 
//       } else {
//         alert("Error deleting entry: " + result.message);
//       }
//     } catch (error) {
//       alert("Server Error.");
//     } finally {
//       setIsDeleting(false); // <-- TURN OFF PROGRESS BAR
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     return new Date(dateString).toLocaleDateString("en-IN");
//   };

//   return (
//     <div className="income-page-container">
//       {/* --- TOP NAV BAR --- */}
//       <div className="income-header-nav">
//         <div className="income-brand" onClick={() => navigate("/home")} style={{ cursor: "pointer" }}>
//           <img src={topLogo} alt="Logo" className="income-logo" />
//           <div className="income-brand-text">
//             <h2>गायत्री परिवार</h2>
//             <h3>अलीराजपुर</h3>
//           </div>
//         </div>
//         <div>
//             <button className="income-logout-btn" onClick={() => navigate("/")}>
//             <FaSignOutAlt /> Sign Out
//             </button>
//         </div>
//       </div>

//       {/* --- MAIN CARD --- */}
//       <div className="income-main-card">
//         <h2 className="income-card-title" style={{ color: '#d32f2f', borderLeftColor: '#d32f2f' }}>
//           दिनांक अनुसार रिकॉर्ड खोजें और हटाएं (Delete Entry By Date)
//         </h2>

//         <form onSubmit={handleSearch}>
//           <div className="income-input-group" style={{ maxWidth: '400px', marginBottom: '20px' }}>
//             <label>दिनांक चुनें (Select Date)</label>
//             <div className="income-input-wrapper">
//               <FaCalendarAlt className="input-icon" />
//               <input 
//                 type="date" 
//                 value={searchDate} 
//                 onChange={(e) => setSearchDate(e.target.value)} 
//                 required 
//               />
//             </div>
//           </div>

//           <button type="submit" className="income-action-btn search-btn" disabled={isLoading} style={{ backgroundColor: '#1976d2' }}>
//             <FaSearch /> {isLoading ? "SEARCHING..." : "SEARCH ENTRIES"}
//           </button>
//         </form>

//         {/* --- PROGRESS BAR --- */}
//         {isLoading && (
//           <div className="loader-wrapper" style={{ marginTop: '20px' }}>
//             <div className="loader-content">
//               <div className="premium-progress-container">
//                 <div className="premium-progress-bar">
//                   <div className="premium-progress-shimmer"></div>
//                 </div>
//               </div>
//               <div className="loading-status">
//                 <span className="spinner-dot"></span>
//                 <p>डेटा खोजा जा रहा है... (Searching Data...)</p>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* --- VERIFICATION POPUP/BOX --- */}
//         {entryToVerify && (
//           <div style={{
//             marginTop: '30px', 
//             padding: '25px', 
//             backgroundColor: '#fff5f5', 
//             border: '2px solid #ef5350', 
//             borderRadius: '10px',
//             boxShadow: '0 4px 12px rgba(239, 83, 80, 0.2)',
//             position: 'relative'
//           }}>
//             <button 
//               onClick={() => setEntryToVerify(null)}
//               style={{ position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', cursor: 'pointer', color: '#666', fontSize: '18px' }}
//               title="Cancel"
//             >
//               <FaTimes />
//             </button>

//             <h3 style={{ color: '#c62828', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
//               <FaTrash /> हटाने से पहले पुष्टि करें (Verify Before Deletion)
//             </h3>
//             <p style={{ color: '#555', marginBottom: '20px' }}>क्या आप सुनिश्चित हैं कि आप इस एंट्री को हमेशा के लिए हटाना चाहते हैं?</p>
            
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', backgroundColor: 'white', padding: '15px', borderRadius: '8px', border: '1px solid #ffcdd2' }}>
//                 <div><strong>दिनांक:</strong> {formatDate(entryToVerify.date)}</div>
//                 <div><strong>रसीद/वाउचर क्र:</strong> {entryToVerify.rasid_no || entryToVerify.voucher_no || "-"}</div>
//                 <div><strong>नाम:</strong> {entryToVerify.name || "-"}</div>
                
//                 {entryToVerify.jama_rashi > 0 ? (
//                   <>
//                     <div style={{ color: '#2e7d32', fontWeight: 'bold' }}><strong>प्रकार:</strong> आय (Income)</div>
//                     <div><strong>विवरण:</strong> {entryToVerify.aai_ka_vivran}</div>
//                     <div style={{ color: '#2e7d32', fontSize: '18px', fontWeight: 'bold' }}><strong>राशि:</strong> ₹ {entryToVerify.jama_rashi}</div>
//                   </>
//                 ) : (
//                   <>
//                     <div style={{ color: '#c62828', fontWeight: 'bold' }}><strong>प्रकार:</strong> व्यय (Expense)</div>
//                     <div><strong>विवरण:</strong> {entryToVerify.vyay_ka_vivran}</div>
//                     <div style={{ color: '#c62828', fontSize: '18px', fontWeight: 'bold' }}><strong>राशि:</strong> ₹ {entryToVerify.nikali_rashi}</div>
//                   </>
//                 )}
                
//                 <div><strong>माध्यम:</strong> {entryToVerify.payment_mode || "OFFLINE"}</div>
//                 {entryToVerify.description && <div style={{ gridColumn: '1 / -1' }}><strong>अतिरिक्त विवरण:</strong> {entryToVerify.description}</div>}
//             </div>

//             <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>

//                {/* --- ACTION BUTTONS OR PROGRESS BAR --- */}
//             {isDeleting ? (
//               <div className="loader-wrapper" style={{ marginTop: '20px', padding: '10px 0' }}>
//                 <div className="loader-content" style={{ maxWidth: '300px', margin: '0 auto' }}>
//                   <div className="premium-progress-container">
//                     {/* Inline style overrides the green gradient to make it red for deletion */}
//                     <div className="premium-progress-bar" style={{ background: 'linear-gradient(90deg, #d32f2f, #ef5350, #d32f2f)' }}>
//                       <div className="premium-progress-shimmer"></div>
//                     </div>
//                   </div>
//                   <div className="loading-status">
//                     <span className="spinner-dot" style={{ backgroundColor: '#d32f2f' }}></span>
//                     <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>रिकॉर्ड हटाया जा रहा है... (Deleting...)</p>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
//                 <button 
//                   onClick={confirmDeletion} 
//                   style={{ backgroundColor: '#d32f2f', color: 'white', padding: '12px 24px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}
//                 >
//                   हां, इसे हटाएं (Yes, Delete It)
//                 </button>
//                 <button 
//                   onClick={() => setEntryToVerify(null)} 
//                   style={{ backgroundColor: 'white', color: '#444', padding: '12px 24px', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}
//                 >
//                   रद्द करें (Cancel)
//                 </button>
//               </div>
//             )}
//             </div>
//           </div>
//         )}

//         {/* --- RESULTS TABLE --- */}
//         {!isLoading && hasSearched && entries.length > 0 && (
//           <div className="income-results-area" style={{ marginTop: '30px', opacity: entryToVerify ? 0.5 : 1, pointerEvents: entryToVerify ? 'none' : 'auto' }}>
//             <h4 className="results-title" style={{ color: '#d32f2f' }}>{formatDate(searchDate)} के सभी रिकॉर्ड</h4>
//             <hr className="results-divider" />

//             <div className="table-responsive">
//               <table className="income-clean-table">
//                 <thead>
//                   <tr>
//                     <th>S.No</th>
//                     <th>रसीद क्र.</th>
//                     <th>नाम (Name)</th>
//                     <th>प्रकार (Type)</th>
//                     <th>विवरण</th>
//                     <th>राशि (Amount)</th>
//                     <th style={{ textAlign: "center" }}>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {entries.map((item, index) => {
//                     const isIncome = item.jama_rashi > 0;
//                     const amount = isIncome ? item.jama_rashi : item.nikali_rashi;
//                     const typeLabel = isIncome ? "आय (Income)" : "व्यय (Expense)";
//                     const descLabel = isIncome ? item.aai_ka_vivran : item.vyay_ka_vivran;
//                     const typeColor = isIncome ? "#4caf50" : "#e53935";

//                     return (
//                       <tr key={item.id}> 
//                         <td>{index + 1}</td>
//                         <td><strong>{item.rasid_no || item.voucher_no}</strong></td>
//                         <td>{item.name}</td>
//                         <td style={{ color: typeColor, fontWeight: 'bold' }}>{typeLabel}</td>
//                         <td>{descLabel}</td>
//                         <td style={{ color: typeColor, fontWeight: 'bold' }}>₹ {amount}</td>
//                         <td style={{ textAlign: "center" }}>
//                           <button 
//                             // Instead of deleting, this opens the verification box!
//                             onClick={() => setEntryToVerify(item)}
//                             style={{ 
//                               backgroundColor: 'white', 
//                               color: '#d32f2f', 
//                               border: '1px solid #d32f2f', 
//                               padding: '6px 12px', 
//                               borderRadius: '4px', 
//                               cursor: 'pointer',
//                               display: 'inline-flex',
//                               alignItems: 'center',
//                               gap: '5px'
//                             }}
//                             title="Verify and Delete"
//                           >
//                             <FaTrash /> Delete
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {!isLoading && hasSearched && entries.length === 0 && (
//           <div className="no-data-card" style={{ marginTop: '30px' }}>
//             <h3>कोई रिकॉर्ड नहीं मिला</h3>
//             <p>इस दिनांक ({formatDate(searchDate)}) के लिए कोई आय या व्यय दर्ज नहीं है।</p>
//           </div>
//         )}
//       </div>

//       {/* --- CUSTOM POPBOX FOR ALERTS (No Data / Errors) --- */}
//       {popupMessage && (
//         <div style={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100vw',
//           height: '100vh',
//           backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           zIndex: 9999,
//           backdropFilter: 'blur(3px)'
//         }}>
//           <div style={{
//             backgroundColor: 'white',
//             padding: '30px',
//             borderRadius: '12px',
//             maxWidth: '400px',
//             width: '90%',
//             textAlign: 'center',
//             boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
//             animation: 'slideUp 0.3s ease-out'
//           }}>
//             <div style={{ fontSize: '45px', color: '#ff9800', marginBottom: '15px' }}>
//               ⚠️
//             </div>
//             <h3 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '20px' }}>
//               सूचना (Notice)
//             </h3>
//             <p style={{ color: '#666', fontSize: '16px', marginBottom: '25px', lineHeight: '1.5' }}>
//               {popupMessage}
//             </p>
//             <button 
//               onClick={() => setPopupMessage(null)} 
//               style={{
//                 backgroundColor: '#1976d2',
//                 color: 'white',
//                 border: 'none',
//                 padding: '10px 30px',
//                 borderRadius: '6px',
//                 fontSize: '16px',
//                 fontWeight: 'bold',
//                 cursor: 'pointer',
//                 boxShadow: '0 2px 5px rgba(25, 118, 210, 0.3)'
//               }}
//             >
//               ठीक है (OK)
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DeleteEntry;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaTrash, FaSignOutAlt, FaArrowLeft, FaCalendarAlt, FaTimes, FaEdit, FaSave } from "react-icons/fa";
import "./IncomeReport.css"; 
import topLogo from "./logo-placeholder.png"; 

const DeleteEntry = () => {
  const navigate = useNavigate();
  const [searchDate, setSearchDate] = useState("");
  const [entries, setEntries] = useState([]);
  
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [popupMessage, setPopupMessage] = useState(null);
  
  // MODAL STATES
  const [entryToVerify, setEntryToVerify] = useState(null); // For Delete
  const [entryToUpdate, setEntryToUpdate] = useState(null); // For Update
  
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  // --- SEARCH BY DATE ---
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchDate) return;

    setIsLoading(true);
    setHasSearched(true);
    setEntries([]); 
    setEntryToVerify(null); 
    setEntryToUpdate(null);

    try {
      const response = await fetch("/api/dashboard/search-entries-by-date", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ searchDate }),
      });
      const result = await response.json();

      if (result.success) {
        setEntries(result.data);
      } else {
        setPopupMessage(result.message || "इस दिनांक का कोई रिकॉर्ड नहीं मिला।");
      }
    } catch (error) {
      setPopupMessage("सर्वर कनेक्शन त्रुटि (Server Connection Error).");
    } finally {
      setIsLoading(false);
    }
  };

  // --- ACTUAL DELETE FUNCTION ---
  const confirmDeletion = async () => {
    if (!entryToVerify) return;
    const entryId = entryToVerify.id || entryToVerify.ID || entryToVerify.Id;

    if (!entryId) {
        setPopupMessage("त्रुटि (Error): इस रिकॉर्ड में ID मौजूद नहीं है।");
        return;
    }

    setIsDeleting(true); 
    try {
      const response = await fetch(`/api/dashboard/delete-entry/${entryId}`, {
        method: "DELETE",
      });
      const result = await response.json();

      if (result.success) {
        setPopupMessage("सफलता! " + result.message);
        setEntries(entries.filter((entry) => (entry.id || entry.ID) !== entryId)); 
        setEntryToVerify(null); 
      } else {
        setPopupMessage("Error deleting entry: " + result.message);
      }
    } catch (error) {
      setPopupMessage("Server Error.");
    } finally {
      setIsDeleting(false); 
    }
  };

  // --- ACTUAL UPDATE FUNCTION ---
  const confirmUpdate = async (e) => {
    e.preventDefault();
    if (!entryToUpdate) return;
    const entryId = entryToUpdate.id || entryToUpdate.ID || entryToUpdate.Id;

    setIsUpdating(true);
    try {
      const response = await fetch(`/api/dashboard/update-entry/${entryId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(entryToUpdate),
      });
      const result = await response.json();

      if (result.success) {
        setPopupMessage("✅ " + result.message);
        // Update the table row locally so we don't need to fetch again
        setEntries(entries.map((entry) => (entry.id === entryId ? entryToUpdate : entry))); 
        setEntryToUpdate(null); 
      } else {
        setPopupMessage("Error updating entry: " + result.message);
      }
    } catch (error) {
      setPopupMessage("Server Error.");
    } finally {
      setIsUpdating(false); 
    }
  };

  // Handles typing in the update form
  const handleUpdateChange = (e) => {
      const { name, value } = e.target;
      setEntryToUpdate({ ...entryToUpdate, [name]: value });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-IN");
  };

  // Safe split for date inputs (YYYY-MM-DD)
  const getRawDate = (dateString) => {
      if(!dateString) return "";
      return dateString.split('T')[0];
  };

  return (
    <div className="income-page-container">
      {/* --- TOP NAV BAR --- */}
      <div className="income-header-nav">
        <div className="income-brand" onClick={() => navigate("/home")} style={{ cursor: "pointer" }}>
          <img src={topLogo} alt="Logo" className="income-logo" />
          <div className="income-brand-text">
            <h2>गायत्री परिवार</h2>
            <h3>अलीराजपुर</h3>
          </div>
        </div>
        <div>
            <button className="income-logout-btn" onClick={() => navigate("/")}>
            <FaSignOutAlt /> Sign Out
            </button>
        </div>
      </div>

      {/* --- MAIN CARD --- */}
      <div className="income-main-card">
        <h2 className="income-card-title" style={{ color: '#1976d2', borderLeftColor: '#1976d2' }}>
          दिनांक अनुसार रिकॉर्ड खोजें, अपडेट करें या हटाएं
        </h2>

        <form onSubmit={handleSearch}>
          <div className="income-input-group" style={{ maxWidth: '400px', marginBottom: '20px' }}>
            <label>दिनांक चुनें (Select Date)</label>
            <div className="income-input-wrapper">
              <FaCalendarAlt className="input-icon" />
              <input type="date" value={searchDate} onChange={(e) => setSearchDate(e.target.value)} required />
            </div>
          </div>

          <button type="submit" className="income-action-btn search-btn" disabled={isLoading} style={{ backgroundColor: '#1976d2' }}>
            <FaSearch /> {isLoading ? "SEARCHING..." : "SEARCH ENTRIES"}
          </button>
        </form>

        {/* --- PROGRESS BAR --- */}
        {isLoading && (
          <div className="loader-wrapper" style={{ marginTop: '20px' }}>
             {/* Your existing progress bar code */}
            <div className="loader-content">
              <div className="premium-progress-container">
                <div className="premium-progress-bar">
                  <div className="premium-progress-shimmer"></div>
                </div>
              </div>
              <div className="loading-status">
                <span className="spinner-dot"></span>
                <p>डेटा खोजा जा रहा है... (Searching Data...)</p>
              </div>
            </div>
          </div>
        )}

        {/* ========================================== */}
        {/* UPDATE VERIFICATION BOX          */}
        {/* ========================================== */}
        {entryToUpdate && (
          <div style={{ marginTop: '30px', padding: '25px', backgroundColor: '#e3f2fd', border: '2px solid #1976d2', borderRadius: '10px', position: 'relative' }}>
            <button onClick={() => setEntryToUpdate(null)} style={{ position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', cursor: 'pointer', color: '#666', fontSize: '18px' }} title="Cancel"><FaTimes /></button>

            <h3 style={{ color: '#1565c0', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaEdit /> रिकॉर्ड अपडेट करें (Update Record)
            </h3>
            
            <form onSubmit={confirmUpdate} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', backgroundColor: 'white', padding: '20px', borderRadius: '8px', border: '1px solid #bbdefb' }}>
                
                {/* Date */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#555' }}>दिनांक (Date)</label>
                    <input type="date" name="date" value={getRawDate(entryToUpdate.date)} onChange={handleUpdateChange} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} required />
                </div>

                {/* Name */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#555' }}>नाम (Name)</label>
                    <input type="text" name="name" value={entryToUpdate.name} onChange={handleUpdateChange} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} required />
                </div>

                {/* Receipt/Voucher Number (Dynamic) */}
                {entryToUpdate.jama_rashi > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#2e7d32' }}>रसीद क्र. (Receipt No)</label>
                      <input 
                        type="text" 
                        name="rasid_no" 
                        value={entryToUpdate.rasid_no || ""} 
                        onChange={handleUpdateChange} 
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #4caf50' }} 
                      />
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#c62828' }}>वाउचर क्र. (Voucher No)</label>
                      <input 
                        type="text" 
                        name="voucher_no" 
                        value={entryToUpdate.voucher_no || ""} 
                        onChange={handleUpdateChange} 
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ef5350' }} 
                      />
                  </div>
                )}

                {/* Amount (Dynamic based on Income/Expense) */}
                {entryToUpdate.jama_rashi > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#2e7d32' }}>आय राशि (Income Amount)</label>
                      <input type="number" name="jama_rashi" value={entryToUpdate.jama_rashi} onChange={handleUpdateChange} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #4caf50' }} required />
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#c62828' }}>व्यय राशि (Expense Amount)</label>
                      <input type="number" name="nikali_rashi" value={entryToUpdate.nikali_rashi} onChange={handleUpdateChange} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ef5350' }} required />
                  </div>
                )}

                {/* Category Dropdowns (Dynamic) */}
                {entryToUpdate.jama_rashi > 0 ? (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#555' }}>आय का विवरण (Income Category)</label>
                      <select 
                        name="aai_ka_vivran" 
                        value={entryToUpdate.aai_ka_vivran || ""} 
                        onChange={handleUpdateChange} 
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: 'white' }} 
                        required
                      >
                          <option value="">विवरण का चयन करे</option>
                          <option value="गायत्री यज्ञ">गायत्री यज्ञ</option>
                          <option value="यज्ञ कुण्ड">यज्ञ कुण्ड</option>
                          <option value="अंशदान">अंशदान</option>
                          <option value="आओ गढे संस्कार वान पीढ़ी">आओ गढे संस्कार वान पीढ़ी</option>
                          <option value="दीक्षा एवं यज्ञोपवीत संस्कार">दीक्षा एवं यज्ञोपवीत संस्कार</option>
                          <option value="अन्य संस्कार से प्राप्त आय">अन्य संस्कार से प्राप्त आय</option>
                          <option value="नवरात्री पर्व">नवरात्री पर्व</option>
                          <option value="दान पेटी से प्राप्त आय">दान पेटी से प्राप्त आय</option>
                          <option value="वस्तु दान की बिक्री से आय">वस्तु दान की बिक्री से आय</option>
                          <option value="गौशाला हेतु दान">गौशाला हेतु दान</option>
                          <option value="साहित्य से बिक्री">साहित्य से बिक्री</option>
                          <option value="बैंक ब्याज से प्राप्त आय">बैंक ब्याज से प्राप्त आय</option>
                          <option value="अन्य स्रोत से आय">अन्य स्रोत से आय</option>
                      </select>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#555' }}>व्यय का विवरण (Expense Category)</label>
                      <select 
                        name="vyay_ka_vivran" 
                        value={entryToUpdate.vyay_ka_vivran || ""} 
                        onChange={handleUpdateChange} 
                        style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: 'white' }} 
                        required
                      >
                          <option value="">विवरण का चयन करे</option>
                          <option value="यज्ञ व पूजन सामग्री व्यय">यज्ञ व पूजन सामग्री व्यय</option>
                          <option value="परीवाजक मानदेय राशि">परीवाजक मानदेय राशि</option>
                          <option value="भोजनालय व्यय">भोजनालय व्यय</option>
                          <option value="गौशाला हेतु दान">गौशाला हेतु दान</option>
                          <option value="समारोह आयोजन व्यय">समारोह आयोजन व्यय</option>
                          <option value="विधुत व्यय">विधुत व्यय</option>
                          <option value="स्टेशनरी व्यय">स्टेशनरी व्यय</option>
                          <option value="कार्यालयीन व्यय">कार्यालयीन व्यय</option>
                          <option value="ट्रस्ट द्वारा दी गई भेट राशि">ट्रस्ट द्वारा दी गई भेट राशि</option>
                          <option value="भवन मर्मद व्यय">भवन मर्मद व्यय</option>
                          <option value="कम्प्यूटर व्यय">कम्प्यूटर व्यय</option>
                          <option value="परिव्राज चिकित्सा व्यय">परिव्राज चिकित्सा व्यय</option>
                          <option value="परिव्रजा व्यय (पेट्रोल ,डीजल )">परिव्रजा व्यय (पेट्रोल ,डीजल )</option>
                          <option value="अंकेक्षण शुल्क">अंकेक्षण शुल्क</option>
                          <option value="बैंक में जमा">बैंक में जमा</option>
                          <option value="अन्य सामान व्यय">अन्य सामान व्यय</option>
                          <option value="मार्ग यात्रा व्यय">मार्ग यात्रा व्यय</option>
                      </select>
                  </div>
                )}

                {/* Payment Mode */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#555' }}>माध्यम (Payment Mode)</label>
                    <select name="payment_mode" value={entryToUpdate.payment_mode || "OFFLINE"} onChange={handleUpdateChange} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}>
                        <option value="OFFLINE">OFFLINE</option>
                        <option value="ONLINE">ONLINE</option>
                    </select>
                </div>

                {/* --- ACTION BUTTONS OR PROGRESS BAR --- */}
                {isUpdating ? (
                  <div className="loader-wrapper" style={{ marginTop: '20px', padding: '10px 0', gridColumn: '1 / -1' }}>
                    <div className="loader-content" style={{ maxWidth: '300px', margin: '0 auto' }}>
                      <div className="premium-progress-container">
                        {/* Blue Gradient for Update Progress */}
                        <div className="premium-progress-bar" style={{ background: 'linear-gradient(90deg, #1565c0, #42a5f5, #1565c0)' }}>
                          <div className="premium-progress-shimmer"></div>
                        </div>
                      </div>
                      <div className="loading-status">
                        <span className="spinner-dot" style={{ backgroundColor: '#1565c0' }}></span>
                        <p style={{ color: '#1565c0', fontWeight: 'bold' }}>रिकॉर्ड अपडेट किया जा रहा है... (Updating...)</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: '15px', marginTop: '15px', gridColumn: '1 / -1' }}>
                    <button 
                      type="submit" 
                      style={{ backgroundColor: '#1976d2', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                      <FaSave /> अपडेट करें (Save Changes)
                    </button>
                    <button 
                      type="button" 
                      onClick={() => setEntryToUpdate(null)} 
                      style={{ backgroundColor: 'white', color: '#444', padding: '10px 20px', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}
                    >
                      रद्द करें (Cancel)
                    </button>
                  </div>
                )}
            </form>
          </div>
        )}

        {/* ========================================== */}
        {/* DELETE VERIFICATION BOX          */}
        {/* ========================================== */}
        {entryToVerify && (
          <div style={{ marginTop: '30px', padding: '25px', backgroundColor: '#fff5f5', border: '2px solid #ef5350', borderRadius: '10px', position: 'relative' }}>
             {/* ... Your Existing Delete Verification Code (Unchanged) ... */}
            <button onClick={() => setEntryToVerify(null)} style={{ position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', cursor: 'pointer', color: '#666', fontSize: '18px' }} title="Cancel"><FaTimes /></button>

            <h3 style={{ color: '#c62828', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaTrash /> हटाने से पहले पुष्टि करें (Verify Before Deletion)
            </h3>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', backgroundColor: 'white', padding: '15px', borderRadius: '8px', border: '1px solid #ffcdd2' }}>
                <div><strong>दिनांक:</strong> {formatDate(entryToVerify.date)}</div>
                <div><strong>रसीद/वाउचर क्र:</strong> {entryToVerify.rasid_no || entryToVerify.voucher_no || "-"}</div>
                <div><strong>नाम:</strong> {entryToVerify.name || "-"}</div>
                
                {entryToVerify.jama_rashi > 0 ? (
                  <>
                    <div style={{ color: '#2e7d32', fontWeight: 'bold' }}><strong>प्रकार:</strong> आय (Income)</div>
                    <div><strong>विवरण:</strong> {entryToVerify.aai_ka_vivran}</div>
                    <div style={{ color: '#2e7d32', fontSize: '18px', fontWeight: 'bold' }}><strong>राशि:</strong> ₹ {entryToVerify.jama_rashi}</div>
                  </>
                ) : (
                  <>
                    <div style={{ color: '#c62828', fontWeight: 'bold' }}><strong>प्रकार:</strong> व्यय (Expense)</div>
                    <div><strong>विवरण:</strong> {entryToVerify.vyay_ka_vivran}</div>
                    <div style={{ color: '#c62828', fontSize: '18px', fontWeight: 'bold' }}><strong>राशि:</strong> ₹ {entryToVerify.nikali_rashi}</div>
                  </>
                )}
            </div>

            {isDeleting ? (
               <p style={{ color: '#d32f2f', fontWeight: 'bold', marginTop: '20px' }}>रिकॉर्ड हटाया जा रहा है... (Deleting...)</p>
            ) : (
              <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
                <button onClick={confirmDeletion} style={{ backgroundColor: '#d32f2f', color: 'white', padding: '12px 24px', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}>
                  हां, इसे हटाएं (Yes, Delete It)
                </button>
                <button onClick={() => setEntryToVerify(null)} style={{ backgroundColor: 'white', color: '#444', padding: '12px 24px', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}>
                  रद्द करें (Cancel)
                </button>
              </div>
            )}
          </div>
        )}

        {/* --- RESULTS TABLE --- */}
        {!isLoading && hasSearched && entries.length > 0 && (
          <div className="income-results-area" style={{ marginTop: '30px', opacity: (entryToVerify || entryToUpdate) ? 0.5 : 1, pointerEvents: (entryToVerify || entryToUpdate) ? 'none' : 'auto' }}>
            <h4 className="results-title" style={{ color: '#1976d2' }}>{formatDate(searchDate)} के सभी रिकॉर्ड</h4>
            <hr className="results-divider" />

            <div className="table-responsive">
              <table className="income-clean-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>रसीद क्र.</th>
                    <th>नाम (Name)</th>
                    <th>प्रकार (Type)</th>
                    <th>विवरण</th>
                    <th>राशि (Amount)</th>
                    <th style={{ textAlign: "center" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map((item, index) => {
                    const isIncome = item.jama_rashi > 0;
                    const amount = isIncome ? item.jama_rashi : item.nikali_rashi;
                    const typeLabel = isIncome ? "आय (Income)" : "व्यय (Expense)";
                    const descLabel = isIncome ? item.aai_ka_vivran : item.vyay_ka_vivran;
                    const typeColor = isIncome ? "#4caf50" : "#e53935";

                    return (
                      <tr key={item.id}> 
                        <td>{index + 1}</td>
                        <td><strong>{item.rasid_no || item.voucher_no}</strong></td>
                        <td>{item.name}</td>
                        <td style={{ color: typeColor, fontWeight: 'bold' }}>{typeLabel}</td>
                        <td>{descLabel}</td>
                        <td style={{ color: typeColor, fontWeight: 'bold' }}>₹ {amount}</td>
                        
                        {/* THE NEW ACTION BUTTONS */}
                        <td style={{ textAlign: "center", display: "flex", gap: "10px", justifyContent: "center" }}>
                          <button 
                            onClick={() => { setEntryToUpdate(item); setEntryToVerify(null); }}
                            style={{ backgroundColor: '#e3f2fd', color: '#1565c0', border: '1px solid #1565c0', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                            title="Edit this entry"
                          >
                            <FaEdit /> Edit
                          </button>
                          
                          <button 
                            onClick={() => { setEntryToVerify(item); setEntryToUpdate(null); }}
                            style={{ backgroundColor: '#fff5f5', color: '#d32f2f', border: '1px solid #d32f2f', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                            title="Delete this entry"
                          >
                            <FaTrash /> Delete
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {!isLoading && hasSearched && entries.length === 0 && (
          <div className="no-data-card" style={{ marginTop: '30px' }}>
            <h3>कोई रिकॉर्ड नहीं मिला</h3>
            <p>इस दिनांक ({formatDate(searchDate)}) के लिए कोई आय या व्यय दर्ज नहीं है।</p>
          </div>
        )}
      </div>

      {/* --- CUSTOM POPBOX FOR ALERTS --- */}
      {popupMessage && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, backdropFilter: 'blur(3px)' }}>
          <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '12px', maxWidth: '400px', width: '90%', textAlign: 'center', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}>
            <p style={{ color: '#333', fontSize: '18px', marginBottom: '25px', fontWeight: 'bold' }}>{popupMessage}</p>
            <button onClick={() => setPopupMessage(null)} style={{ backgroundColor: '#1976d2', color: 'white', border: 'none', padding: '10px 30px', borderRadius: '6px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}>
              ठीक है (OK)
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteEntry;